import getApiClient from '@/plugins/api-client'

export default {
  downloadFeedbackReport: function (event) {
    const self = this
    const api = getApiClient(self.$store)

    self.$store.state.loading = true
    api.get(`${event['@id']}/feedback_report`, {responseType: 'blob'})
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data])),
          link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${event.name} - Relatório de feedbacks - Castfy.pdf`)
        document.body.appendChild(link)
        link.click()
      })
      .catch(() => {
      })
      .finally(() => {
        self.$store.state.loading = false
      })
  }
}
